// extracted by mini-css-extract-plugin
export var adjustableWidthBorder = "_4p-7";
export var adjustableWidthBorderHeld = "_4p-8";
export var arrow = "_4p-3";
export var arrowButton = "_4p-4";
export var headerCell = "_4p-0";
export var help = "_4p-2";
export var icon = "_4p-1";
export var iconWrapper = "_4p-6";
export var noBorder = "_4p-b";
export var nonAdjustableWidthBorder = "_4p-9";
export var nonAdjustableWidthBorderHeld = "_4p-a";
export var textButton = "_4p-5";